import * as React from 'react';
import Dialog from '@mui/material/Dialog';
// import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
// import DialogContentText from '@mui/material/DialogContentText';
import { Box, Button, DialogActions, Divider, Grid, Stack, TextField, Typography } from '@mui/material';
import { useState } from 'react';
import { useEffect } from 'react';
import { getConfigFile } from 'API/Config/api';
import {
    ApproveReuploadRequest,
    GetFieldData,
    GetFieldDataFromKyc, 
    // getImagesCSPkyc,
     SendReuploadFile
} from 'API/Approval/api';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
// import ImageModal from '../Approval/Components/ImageModal';
// import { Stack } from '@mui/system';
import { styled } from '@mui/material/styles';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { IoClose } from "react-icons/io5";
import axios from 'axios';
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { FaEye } from "react-icons/fa6";
import { FaUpload } from "react-icons/fa";
import { FaCamera } from "react-icons/fa";
import CaptureDialog from './CaptureDialog';
import { useRef } from 'react';
import ViewAllFiles from './ViewAllFiles';






const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
});

export default function DocumentModal(props) {
    const [configData, setConfigData] = useState(null)
    const [FilteredData, setFilteredData] = useState(null)

    const [Selected, setSelected] = useState(null)
    const [UserData, setUserData] = useState(null)
    const [open, setOpen] = React.useState(false);
    const [AlertMessage, setAlertMessage] = useState("")
    const [AlertType, setAlertType] = useState('success')
    // const [Image, setImage] = useState(null)
    // const [OpenImage, setOpenImage] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    // const [fileType, setFileType] = useState(null)
    const [PostData, setPostData] = useState({})
    const [DocumentUploadedData, setDocumentUploadedData] = useState({})
    const [unavailableKeys, setUnavailableKeys] = useState([]);
    const [OpenLiveCapture, setOpenLiveCapture] = useState(false)
    const [CapureFileName, setCaptureFileName] = useState("")
    const [ViewDocumentFiles,setViewDocumentFiles]=useState(false)
    const [DocumentFiles, setDocumentFiles] = useState(null)
    const captureFileNameRef = useRef("");
    const userIdRef=useRef("")
    const SelectRef=useRef(null)
    const zip = new JSZip();


    useEffect(()=>{
        captureFileNameRef.current=null
        userIdRef.current=null
        SelectRef.current=null
    },[props.open])


    const handleViewDocumentFiles=(field,value)=>{
        setViewDocumentFiles(true)
        setDocumentFiles({field,value})
    }

    const handleViewDocumentClose=()=>{
        setViewDocumentFiles(false)
        setDocumentFiles(null)
    }



    const handleOpenLiveCapture = (name) => {
        setOpenLiveCapture(true)
        setCaptureFileName(name)
        captureFileNameRef.current=null
        userIdRef.current=null
        SelectRef.current=null
        captureFileNameRef.current = name;
        userIdRef.current=props.data.user_id 
        SelectRef.current=Selected
    }

    const handleCloseLiveCapture = () => {
        setOpenLiveCapture(false)
        captureFileNameRef.current = null;
        userIdRef.current=null 
        SelectRef.current=null
    }



    // const handleOpenImage = () => {
    //     setOpenImage(true)
    // }

    // const handleCloseImage = () => {
    //     setOpenImage(false)
    // }

    const handleClick = () => {
        setOpen(true);
    };

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpen(false);
    };

useEffect(()=>{

    console.log("CameraFile",CapureFileName);
},[CapureFileName])
    

    const [DummyData, setDummyData] = useState()
    const [AllData, setAllData] = useState()

    useEffect(() => {
        if (FilteredData) {
            let filter = FilteredData.map(filtered => {
                return filtered.fields.map(field => {
                    if (field.field_type !== "Documents" && field.required) {
                        return field.field_name;
                    }
                    // else if (field.field_type === "Documents" && field.required) {
                    //     return field.field_name
                    // }
                    return undefined;
                }).filter(fieldName => fieldName !== undefined);
            }).flat();

            setDummyData(filter)
        }
    }, [FilteredData])



    useEffect(() => {
        if (DummyData) {
            GetFieldData(setAllData, DummyData, props.data.user_id)
        }
    }, [DummyData])



    const handleFormOpen = (category) => {
        setSelected(category)
    }

    useEffect(() => {
        setSelected(null)
    }, [props.handleClose])


    // const handleViewFile = (field) => {
    //     let url = UserData[0][field]
    //     console.log("asdas", UserData);

    //     getImagesCSPkyc(url, setImage, handleOpenImage, handleClick, setFileType, setIsLoading)
    // }

    useEffect(() => {
        if (props.data && configData) {
            let filter = configData.filter((item) => item._id === props.data.product_id)
            let category = filter && filter.length > 0 && filter[0].flow === 2 ? filter[0].categories : null
            setFilteredData(category)

        }
    }, [props.data, configData, UserData])

    useEffect(() => {
        getConfigFile(setConfigData)

    }, [])

    const getFieldsValue = () => {
        console.log("Selected", Selected);
        
        if (Selected) {
            let userdata = Selected.fields.map(item => item.field_name)
            GetFieldDataFromKyc(setUserData, userdata, props.data.user_id?props.data.user_id:userIdRef.current, setIsLoading)
            // handleCloseLiveCapture()
        }
        else if(SelectRef.current){
            let userdata = SelectRef.current.fields.map(item => item.field_name)
            GetFieldDataFromKyc(setUserData, userdata, props.data.user_id?props.data.user_id:userIdRef.current, setIsLoading)
            // handleCloseLiveCapture()
        }
    }



    useEffect(() => {
        getFieldsValue()
    }, [Selected])


    const handleBack = () => {
        setSelected(null)
    }

    const handleDataChange = (value, field_name, field_details) => {
        console.log("details", field_details);

        if (field_name === 'email_address' && /^[a-zA-Z0-9@.]*$/.test(value)) {
            setPostData({ ...PostData, [field_name]: value })
        }
        if (field_name === 'csp_type') {
            setPostData({ ...PostData, [field_name]: value, csp_code: null })
        }
        if (((field_details && field_details.Regex ? new RegExp(field_details.Regex).test(value) : /^[a-zA-Z0-9\s]*$/.test(value))) && (field_details.maxLength ? value.length <= field_details.maxLength : value.length < 20)) {
            setPostData({ ...PostData, [field_name]: value })
        }
        else {
            setPostData({ ...PostData, [field_name]: value })
        }

    }



    useEffect(() => {
        if (unavailableKeys.length > 0) {
            console.log('trigger');

            const foundCategoryNames = unavailableKeys.reduce((acc, field) => {
                FilteredData.forEach(obj => {
                    const isFieldAbsentInOtherCategories = !FilteredData.some(category =>
                        category.fields.some(f => f.field_name === field) && category.category_display_name !== obj.category_display_name
                    );

                    if (isFieldAbsentInOtherCategories && !acc.includes(obj.category_display_name)) {
                        acc.push(obj.category_display_name);
                    }
                });
                return acc;
            }, []);

            console.log(foundCategoryNames);

            if (foundCategoryNames.length > 0) {
                setAlertMessage(`Please fill all required fields in ${foundCategoryNames.join(', ')}`);
                setAlertType('error');
                handleClick();
            }
        }
    }, [unavailableKeys]);




    const handleFileReupload = (name, file) => {

        let maxSize = 5 * 1024 * 1024;
        if (file.size > maxSize) {
            setAlertMessage("File size should be less than 5MB")
            setAlertType("error")
            handleClick()

        }
        else if (!['image/jpeg', 'image/png', 'application/pdf'].includes(file.type)) {
            setAlertMessage("Invalid file type. Please upload either .jpeg, .png or PDF")
            setAlertType("error")
            handleClick()
        }
        else {

            SendReuploadFile(file, name, props.data.user_id, setAlertMessage, setAlertType, handleClick, getFieldsValue, setIsLoading, setDocumentUploadedData, DocumentUploadedData,handleCloseLiveCapture)
        }
    }

    function base64ToFile(base64Data, fileName) {
        const arr = base64Data.split(',');
        const mime = arr[0].match(/:(.*?);/)[1]; // Should be 'image/jpeg' or 'image/png'
        const bstr = atob(arr[1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);
    
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
    
        // Ensure the file has correct extension
        let extension = mime === 'image/png' ? '.png' : '.jpg'; // default to jpg
        if (!fileName.endsWith(extension)) {
            fileName += extension;
        }
    
        return new File([u8arr], fileName, { type: mime });
    }
    
    

    const handleFileCapture = (file) => {

        const Filename=captureFileNameRef.current
        const userId=userIdRef.current
        
        console.log("file", CapureFileName, props, Filename, userId);

        let fileConverted=base64ToFile(file, Filename)
       
            if((CapureFileName||Filename) && (props.data.user_id||userId)){

                SendReuploadFile(fileConverted, CapureFileName?CapureFileName:Filename, props.data.user_id?props.data.user_id:userId, setAlertMessage, setAlertType, handleClick, getFieldsValue, setIsLoading, setDocumentUploadedData, DocumentUploadedData,handleCloseLiveCapture)
            }
        
    }



    function checkKeys(requiredKeys, obj1, obj2, obj3) {
        setIsLoading(true);

        const exceptions = ["mobile_number_2", "ssa_name", "mobile_number_2", "home_landmark"];
        const keysNotAvailable = [];

        const result = requiredKeys.every(key => {
            if (!exceptions.includes(key)) {
                if (key === 'csp_code') {
                    if (PostData['csp_type'] && PostData['csp_type'] !== 'new') {
                        const isAvailable = (key in obj1 && obj1[key]) || (key in obj2 && obj2[key] || (key in obj3 && obj3[key]))
                        if (!isAvailable) {
                            keysNotAvailable.push(key);
                        }
                        return isAvailable;
                    }

                }
                else {
                    const isAvailable = (key in obj1 && obj1[key]) || (key in obj2 && obj2[key] || (key in obj3 && obj3[key]));
                    if (!isAvailable) {
                        keysNotAvailable.push(key);
                    }
                    return isAvailable;
                }

            }
            return true;
        });

        setUnavailableKeys(keysNotAvailable);
        setIsLoading(false);
        return result;
    }
    const handleApproveRequest = () => {

        const isAllPresent = checkKeys(DummyData, AllData[0], PostData, DocumentUploadedData)
        // console.log("check status",isAllPresent);

        if (isAllPresent) {
            setIsLoading(false)
            console.log(PostData);
            ApproveReuploadRequest(props.data.user_id, props.data.product_id, PostData, setAlertMessage, setAlertType, handleClick, setIsLoading)
        }

    }

    useEffect(() => {

        if (props.open) {
            setPostData({})
        }
    }, [props.handleClose])


    const url = process.env.REACT_APP_APPROVAL_URL;
   
    // const handleFileDownloadAll = async () => {
    //     setIsLoading(true);

    //     try {
    //         const downloadPromises = Object.entries(UserData[0]).map(async ([key, value]) => {
    //             if (value) {
    //                 try {
    //                     const response = await axios.post(`${url}/download`, { url: value }, { responseType: 'arraybuffer' });
    //                     if (response.status === 200) {
    //                         const contentType = response.headers['content-type'];
    //                         let fileExtension = key;
    //                         if (contentType === 'application/pdf') {
    //                             fileExtension = `${key}.pdf`;
    //                         } else if (contentType.startsWith('image/')) {
    //                             fileExtension = `${key}.jpg`;
    //                         } else {
    //                             fileExtension = `${key}.bin`;
    //                         }
    //                         zip.file(fileExtension, response.data);
    //                     } else {
    //                         throw new Error('Network response was not ok.');
    //                     }
    //                 } catch (error) {
    //                     console.error(`Error downloading file ${key}:`, error);
    //                 }
    //             }
    //         });

    //         await Promise.all(downloadPromises);
    //         const zipBlob = await zip.generateAsync({ type: 'blob' });
    //         saveAs(zipBlob, `${props.data.agent_name}${props.data.agent_code ? "_" + props.data.agent_code : ''}.zip`);
    //     } catch (error) {
    //         alert('Error downloading multiple images');
    //         console.error('Error downloading multiple images:', error);
    //     } finally {
    //         setIsLoading(false);
    //     }
    // }

     const handleFileDownloadAll = async () => {
  console.log("Download all");

  setIsLoading(true);

  try {
    const downloadPromises = [];

    Object.entries(UserData[0]).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        value.forEach((fileUrl, index) => {
          if (fileUrl) {
            const promise = axios
              .post(`${url}/download`, { url: fileUrl }, { responseType: 'arraybuffer' })
              .then((response) => {
                if (response.status === 200) {
                  const contentType = response.headers['content-type'];
                  let fileExtension = key;
                  if (contentType === 'application/pdf') {
                    fileExtension = `${key}_${index + 1}.pdf`;
                  } else if (contentType.startsWith('image/')) {
                    fileExtension = `${key}_${index + 1}.jpg`;
                  } else {
                    fileExtension = `${key}_${index + 1}.bin`;
                  }
                  zip.file(fileExtension, response.data);
                } else {
                  throw new Error('Network response was not ok.');
                }
              })
              .catch((error) => {
                console.error(`Error downloading file ${key}[${index}]:`, error);
              });

            downloadPromises.push(promise);
          }
        });
      }
    });

    await Promise.all(downloadPromises);
    const zipBlob = await zip.generateAsync({ type: 'blob' });
     saveAs(zipBlob, `${props.data.agent_name}${props.data.agent_code ? "_" + props.data.agent_code : ''}.zip`);
  } catch (error) {
    alert('Error downloading multiple images');
    console.error('Error downloading multiple images:', error);
  } finally {
    setIsLoading(false);
  }
};

    const shouldDisplay = (field) => {
        if (field.field_name === 'csp_code') {
            const isUserDataValid = UserData && UserData[0] && UserData[0]['csp_type'] !== 'new' && !PostData['csp_type'];
            const isPostDataValid = PostData && PostData['csp_type'] && PostData['csp_type'] !== 'new';

            return isUserDataValid || isPostDataValid;
        }
        else {
            return (field.required === 'true' || field.required) && field.field_name !== 'csp_code';
        }
    };

    console.log("postdata", PostData);


    return (
        <React.Fragment >

            <CaptureDialog open={OpenLiveCapture} handleClose={handleCloseLiveCapture} handleCapture={handleFileCapture} isLoading={isLoading}/>
            <Snackbar anchorOrigin={{ horizontal: 'right', vertical: 'top' }} open={open} autoHideDuration={6000} onClose={handleClose}>
                <Alert
                    onClose={handleClose}
                    severity={AlertType}
                    variant="filled"
                    sx={{ width: '100%' }}
                >
                    {AlertMessage}
                </Alert>
            </Snackbar>

            {/* <ImageModal fileType={fileType} image={Image} open={OpenImage} handleClose={handleCloseImage} /> */}

            <Dialog
                open={props.open}
                onClose={props.handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                fullWidth={true}
                maxWidth={Selected ? 'lg' : 'xs'}

            >

                <Backdrop
                    sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 2 }}
                    open={isLoading}
                >
                    <CircularProgress color="inherit" />
                </Backdrop>
                <Box
                    sx={{
                        position: 'absolute',
                        top: 8,
                        right: 8,
                        fontSize: '24px',
                        cursor: 'pointer',
                        display: Selected ? 'none' : 'block'
                    }}
                    onClick={props.handleClose}
                >
                    <IoClose />
                </Box>
                <DialogContent sx={{ width: '100%', height: Selected ? '80vh' : '100%', scrollbarWidth: 'none' }}>
                    {
                        Selected ?
                            ViewDocumentFiles?
                                <ViewAllFiles handleGet={getFieldsValue} userId={props.data.user_id?props.data.user_id:userIdRef.current} field={DocumentFiles.field} value={DocumentFiles.value} handleClose={()=>handleViewDocumentClose()} />
                                :
                                <Grid container spacing={2} paddingInline={2}>
                                <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                                    <Box sx={{
                                        position: 'absolute',
                                        top: 10,
                                        right: 10,
                                        fontSize: '24px',
                                        cursor: 'pointer',
                                    }} variant='outlined' onClick={() => handleBack()}><IoClose /></Box>
                                </Grid>

                                {
                                    Selected.fields.map((field, index) => (
                                        field.field_type === 'Text' || field.field_type === 'Date' || field.field_type === 'Plugin' || field.field_type === 'Function Call' || field.field_type === 'bankname' || field.field_type === 'bankifsc' ?
                                            <Grid item xl={4} lg={4} md={4} sm={4} xs={12} key={index}>

                                                <Typography variant='h5' sx={{ display: 'flex' }}>{field.field_display_name}<span style={{
                                                    color: 'red', display: shouldDisplay(field) ? 'block' : 'none'
                                                }}>*</span></Typography>
                                                <TextField
                                                    variant='outlined'
                                                    value={(props.type === 'rejected' && (PostData[field.field_name] || PostData[field.field_name] === '')) ? PostData[field.field_name] : UserData && UserData[0][field.field_name] ? UserData[0][field.field_name] === 'true' ? "Yes" : UserData[0][field.field_name] === 'false' ? "No" : UserData[0][field.field_name] : PostData[field.field_name] ? PostData[field.field_name] : ''}
                                                    onChange={(e) => props.type === 'rejected' ? handleDataChange(e.target.value, field.field_name, field.field_details) : UserData[0][field.field_name] ? null : handleDataChange(e.target.value, field.field_name, field.field_details)}
                                                    InputLabelProps={{ shrink: true }}
                                                    sx={{
                                                        input: {
                                                            background: props.type === 'rejected' ? '#FFFFF2' : UserData && UserData[0][field.field_name] ? '#f0f0f0' : '#FFFFF2'
                                                        }
                                                    }}
                                                    fullWidth
                                                    inputProps={{
                                                        readOnly: props.type === 'rejected' || props.type === 'approved' ? false : UserData && UserData[0][field.field_name] ? true : false,
                                                    }}
                                                />
                                            </Grid>
                                            :
                                            field.field_type === 'Option' || field.field_type === 'Select List' ?
                                                <Grid item xl={4} lg={4} md={4} sm={4} xs={12} key={index} gap={2}>
                                                    <Typography variant='h5' sx={{ display: 'flex' }}>{field.field_display_name}<span style={{ color: 'red', display: (field.required === 'true' || field.required) ? 'block' : 'none' }}>*</span></Typography>

                                                    <FormControl fullWidth>
                                                        <Select
                                                            labelId="demo-simple-select-label"
                                                            id="demo-simple-select"
                                                            value={(props.type === 'rejected' && PostData[field.field_name]) ? PostData[field.field_name] : UserData && UserData[0][field.field_name] ? UserData[0][field.field_name] : PostData[field.field_name] ? PostData[field.field_name] : ''}
                                                            inputProps={{
                                                                readOnly: props.type === 'rejected' ? false : UserData && UserData[0][field.field_name] ? true : false,
                                                            }}
                                                            sx={{
                                                                '& .MuiSelect-select': {
                                                                    background: props.type === 'rejected'
                                                                        ? '#FFFFF2'
                                                                        : UserData && UserData[0][field.field_name]
                                                                            ? '#f0f0f0'
                                                                            : '#FFFFF2'
                                                                },
                                                                '& .MuiSelect-icon': props.type === 'rejected' ? {} : UserData && UserData[0][field.field_name] ? { display: 'none' } : {},
                                                            }}
                                                            onChange={(e) => props.type === 'rejected' ? handleDataChange(e.target.value, field.field_name, field.field_details) : UserData[0][field.field_name] ? null : handleDataChange(e.target.value, field.field_name, field.field_details)}
                                                        >
                                                            <MenuItem sx={{ display: 'none' }} value={UserData && UserData[0][field.field_name] ? UserData[0][field.field_name] : PostData[field.field_name] ? PostData[field.field_name] : ''}>{UserData && UserData[0][field.field_name] ? UserData[0][field.field_name] : PostData[field.field_name] ? PostData[field.field_name] : ''}</MenuItem>

                                                            {
                                                                field.field_details.options.map((item, index) => (

                                                                    <MenuItem value={item.value} key={index}>{item.Displayname}</MenuItem>
                                                                ))
                                                            }

                                                        </Select>
                                                    </FormControl>
                                                </Grid>
                                                :
                                                field.field_type === 'Dependent Plugin' ?
                                                    <>
                                                        <Grid item xl={4} lg={4} md={4} sm={4} xs={12} key={index}>

                                                            <Typography variant='h5' sx={{ display: 'flex' }}>{field.field_display_name}<span style={{
                                                                color: 'red', display: shouldDisplay(field) ? 'block' : 'none'
                                                            }}>*</span></Typography>
                                                            <TextField
                                                                variant='outlined'
                                                                value={(props.type === 'rejected' && (PostData[field.field_name] || PostData[field.field_name] === '')) ? PostData[field.field_name] : UserData && UserData[0][field.field_name] ? UserData[0][field.field_name] === 'true' ? "Yes" : UserData[0][field.field_name] === 'false' ? "No" : UserData[0][field.field_name] : PostData[field.field_name] ? PostData[field.field_name] : ''}
                                                                onChange={(e) => props.type === 'rejected' ? handleDataChange(e.target.value, field.field_name, field.field_details) : UserData[0][field.field_name] ? null : handleDataChange(e.target.value, field.field_name, field.field_details)}
                                                                InputLabelProps={{ shrink: true }}
                                                                sx={{
                                                                    input: {
                                                                        background: props.type === 'rejected' ? '#FFFFF2' : UserData && UserData[0][field.field_name] ? '#f0f0f0' : '#FFFFF2'
                                                                    }
                                                                }}
                                                                fullWidth
                                                                inputProps={{
                                                                    readOnly: props.type === 'rejected' || props.type === 'approved' ? false : UserData && UserData[0][field.field_name] ? true : false,
                                                                }}
                                                            />
                                                        </Grid>
                                                        <Grid item xl={4} lg={4} md={4} sm={4} xs={12} key={index}>

                                                            <Typography variant='h5' sx={{ display: 'flex' }}>{field.field_details.dependent_field ? field.field_details.dependent_field.split('_').join(" ") : ""}<span style={{
                                                                color: 'red', display: shouldDisplay(field) ? 'block' : 'none'
                                                            }}>*</span></Typography>
                                                            <TextField
                                                                variant='outlined'
                                                                value={(props.type === 'rejected' && (PostData[field.field_details.dependent_field] || PostData[field.field_details.dependent_field] === '')) ? PostData[field.field_details.dependent_field] : UserData && UserData[0][field.field_details.dependent_field] ? UserData[0][field.field_details.dependent_field] === 'true' ? "Yes" : UserData[0][field.field_details.dependent_field] === 'false' ? "No" : UserData[0][field.field_details.dependent_field] : PostData[field.field_details.dependent_field] ? PostData[field.field_details.dependent_field] : ''}
                                                                onChange={(e) => props.type === 'rejected' ? handleDataChange(e.target.value, fieldfield_details.dependent_field, field.field_details) : UserData[0][field.field_details.dependent_field] ? null : handleDataChange(e.target.value, field.field_details.dependent_field, field.field_details)}
                                                                InputLabelProps={{ shrink: true }}
                                                                sx={{
                                                                    input: {
                                                                        background: props.type === 'rejected' ? '#FFFFF2' : UserData && UserData[0][field.field_details.dependent_field] ? '#f0f0f0' : '#FFFFF2'
                                                                    }
                                                                }}
                                                                fullWidth
                                                                inputProps={{
                                                                    readOnly: props.type === 'rejected' || props.type === 'approved' ? false : UserData && UserData[0][field.field_details.dependent_field] ? true : false,
                                                                }}
                                                            />
                                                        </Grid>
                                                    </>
                                                    :
                                                    <Grid item xl={4} lg={4} md={4} sm={4} xs={12} key={index} gap={2}>
                                                        <table style={{ width: '100%' }}>
                                                            <tr>
                                                                <th style={{ textAlign: 'left' }}>
                                                                    <Stack direction='column'>
                                                                        <Stack direction='row'><span>{field.field_display_name}</span></Stack>
                                                                        <Typography variant='h6' sx={{ fontWeight: 400 }} color="#bfbfbf">Max file size: 5MB, formats: .jpg/.png/.pdf</Typography>
                                                                        <Stack direction='row' spacing={1}>
                                                                            <Button size='medium' variant='outlined' disabled={UserData && UserData[0][field.field_name] ? false : true} color='secondary' onClick={() => handleViewDocumentFiles(field,UserData[0][field.field_name])} sx={{ borderRadius: '5px' }}><FaEye /></Button>                                                                            <Divider orientation="vertical" flexItem />

                                                                            <Button
                                                                                component="label"
                                                                                role={undefined}
                                                                                variant="contained"
                                                                                tabIndex={-1}
                                                                                color='secondary'
                                                                                sx={{ borderRadius: '5' }}
                                                                                size='medium'
                                                                                disabled={props.type === 'approved' ? true : false}
                                                                            >
                                                                                <FaUpload />
                                                                                <VisuallyHiddenInput type="file" onChange={(e) => handleFileReupload(field.field_name, e.target.files[0])} />
                                                                            </Button>

                                                                            <Divider orientation="vertical" flexItem />
                                                                            <Button
                                                                                size='medium'
                                                                                variant='contained'
                                                                                color='warning'
                                                                                onClick={() => handleOpenLiveCapture(field.field_name)}
                                                                                sx={{
                                                                                    borderRadius: '5px',
                                                                                    
                                                                                }}><FaCamera /></Button>


                                                                        </Stack>
                                                                    </Stack></th>
                                                                <th style={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>

                                                                </th>
                                                            </tr>
                                                        </table>
                                                    </Grid>

                                    ))
                                }
                                {
                                    Selected.category_name === "kyc_documents" ?
                                        <Grid container sx={{ justifyContent: 'center', alignItems: 'center' }} mt={5}>
                                            <Grid item xl={2} lg={2} md={2} sm={12} xs={12}>

                                                <Button
                                                    variant='text'
                                                    color='secondary'
                                                    sx={{ borderRadius: '5px', marginLeft: 2 }}
                                                    disabled={Selected ? false : true}
                                                    onClick={() => handleFileDownloadAll()}
                                                    fullWidth
                                                >
                                                    Download All
                                                </Button>
                                            </Grid>
                                        </Grid>
                                        :
                                        null

                                }
                                <Grid container mt={1}>
                                    <Grid item xs={12}>
                                        <Stack direction="row" justifyContent="center" alignItems="center">
                                            {
                                                props.type === 'pending' ?

                                                    <Button variant='contained' color='secondary' onClick={() => handleBack()}>Save</Button>
                                                    :
                                                    null
                                            }
                                        </Stack>
                                    </Grid>
                                </Grid>


                                </Grid>
                            :
                            Array.isArray(AllData) && AllData.length > 0 ?
                                <table style={{ width: '100%' }}>
                                    {
                                        FilteredData && FilteredData.map((filtered, index) => (
                                            filtered.category_nm_access ?
                                                <tr key={index}>
                                                    <td>{filtered.category_display_name}</td>
                                                    <td style={{ display: 'flex', justifyContent: 'flex-start' }}>{<Button sx={{borderRadius:"8px"}} variant='contained' disabled={Array.isArray(AllData) && AllData.length > 0 ? false : true} color='secondary' size='small' onClick={() => handleFormOpen(filtered)}>view</Button>}</td>
                                                </tr>

                                                : null

                                        ))



                                    }
                                </table>
                                :
                                <Stack justifyContent='center' alignItems='center'>
                                    <CircularProgress />
                                </Stack>
                    }

                </DialogContent>

                <DialogActions sx={{ display: 'flex', justifyContent: 'center' }}>

                    {
                        props.type === 'pending' || props.type === 'rejected' ?
                            <Button sx={{ display: Selected ? 'none' : 'flex' ,borderRadius:"10px",backgroundColor:"#688B2A",color:"#fff"}} disabled={Array.isArray(AllData) && AllData.length > 0 ? false : true} onClick={() => handleApproveRequest()} color="success" variant='contained'>
                                {Array.isArray(AllData) && AllData.length > 0 ? "Approve" : "Loading..."}
                            </Button>
                            :
                            null
                    }


                </DialogActions>

            </Dialog>
        </React.Fragment>
    );
}
